import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { DEFAULT_CURRENCIES } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [display, setDisplay] = useState(() => localStorage.getItem("bk_currency") || "TRY");
  const [currencies, setCurrencies] = useState(DEFAULT_CURRENCIES);
  const [rateInfo, setRateInfo] = useState({ updated_at: null, source: null });

  useEffect(() => {
    if (user && typeof user === "object") {
      api
        .get("/meta/currencies")
        .then((res) => {
          setCurrencies(res.data.currencies);
          setRateInfo({ updated_at: res.data.rate_updated_at, source: res.data.rate_source });
        })
        .catch(() => {});
    }
  }, [user]);

  const changeDisplay = (code) => {
    setDisplay(code);
    localStorage.setItem("bk_currency", code);
  };

  return (
    <CurrencyContext.Provider value={{ display, changeDisplay, currencies, rateInfo }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
